import { lazy } from './lazy.js'
import Swiper from 'swiper/bundle';
import {initRequestForm} from "../../../views/sections/request_form";
import {initDirectBookingForm} from "../../../views/sections/direct_form";
import {initToursGrid} from "../../../views/sections/tours_grid";
import {initContactForm} from "../../../views/sections/contact_form";
import {initReviews} from "../../../views/components/reviews_slider";
import {initInstagram} from "../../../views/components/instagram_slider";
import {initTourRoute} from "../../../views/components/tour_route";
import {initTourSlider} from "../../../views/sections/home_tourgrid";
import {initNextDepartures} from "../../../views/components/next_departures";
const Parallax = require('parallax-js')

export const initPage = () => {
  if (lazy) {
    lazy.update()
  }

  initSingle()
  initPopupSliders()
  initRequestForm()
  initContactForm()
  initDirectBookingForm()
  initToursGrid()
  initReviews()
  initInstagram()
  initTourRoute()
  initTourSlider()
  initNextDepartures()

  // iPhone only allows tilt after a permission pop-up, so skip the parallax there (desktop: mouse, Android: tilt)
  var scene = document.getElementById('scene');
  var needsTiltPermission = navigator.maxTouchPoints > 0 && typeof DeviceOrientationEvent !== 'undefined' && typeof DeviceOrientationEvent.requestPermission === 'function';
  if (scene && !needsTiltPermission) {
    var parallaxInstance = new Parallax(scene, {
      relativeInput: true
    });
  }

  const thumbs = new Swiper('.swiper.thumbs', {
    spaceBetween: 4,
    slidesPerView: 'auto',
    freeMode: true,
    watchSlidesProgress: true,
  });

  const main = new Swiper('.swiper.main', {
    spaceBetween: 0,
    thumbs: {
      swiper: thumbs,
    },
  });
}


export const initSingle = () => {
  document.querySelectorAll('.js-popup-open').forEach(cell => {
    cell.addEventListener('click', () => {
      const popupId = cell.dataset.popup;
      console.log(popupId)
      document.getElementById(popupId).classList.add('is-active');
    });
  });

  document.querySelectorAll('.js-popup-close').forEach(close => {
    close.addEventListener('click', (e) => {
      e.stopPropagation();
      close.closest('.popup').classList.remove('is-active');
    });
  });

  // Tour page is one long page: the tabs scroll to their part, and follow along while scrolling
  const tabBar = document.querySelector('.js-tabs')
  const sections = [...document.querySelectorAll('.single-section')]
  if (!tabBar || !sections.length) return

  const tabs = [...tabBar.querySelectorAll('.tab')]
  const stickyOffset = () => {
    const bar = document.querySelector('.tabs-bar')
    return bar ? parseFloat(getComputedStyle(bar).top) + bar.offsetHeight : 150
  }

  const setActive = id => {
    tabs.forEach(tab => tab.classList.toggle('active', tab.dataset.id === id))

    // keep the active tab in view on phones, where the tab bar scrolls sideways
    const active = tabs.find(tab => tab.dataset.id === id)
    if (active && tabBar.scrollWidth > tabBar.clientWidth) {
      tabBar.scrollTo({ left: active.offsetLeft - (tabBar.clientWidth - active.offsetWidth) / 2, behavior: 'smooth' })
    }
  }

  let scrollingTo = null
  const scrollToSection = (id, behavior = 'smooth') => {
    const section = document.getElementById(id)
    if (!section) return

    scrollingTo = id
    setActive(id)
    window.scrollTo({ top: section.getBoundingClientRect().top + window.scrollY - stickyOffset() + 1, behavior })
    clearTimeout(scrollToSection.timer)
    scrollToSection.timer = setTimeout(() => { scrollingTo = null }, 900)
  }

  // Shareable links: /bike-tours/some-tour/?day-to-day opens at that part
  const tabUrl = id => window.location.pathname + (id === 'overview' ? '' : `?${id}`) + window.location.hash

  document.querySelectorAll('.js-single-tab-button').forEach(button => {
    button.addEventListener('click', () => {
      const id = button.dataset.id
      scrollToSection(id)
      window.history.replaceState({ ...window.history.state, path: window.location.origin + tabUrl(id) }, '', tabUrl(id))
    })
  })

  // Highlight the part that's currently under the tab bar
  const onScroll = () => {
    if (scrollingTo || !document.body.contains(tabBar)) return
    const line = stickyOffset() + 40
    let current = sections[0].id
    sections.forEach(section => {
      if (section.getBoundingClientRect().top <= line) current = section.id
    })
    if (!tabs.find(tab => tab.classList.contains('active') && tab.dataset.id === current)) setActive(current)
  }
  window.removeEventListener('scroll', window.__tourScrollSpy || (() => {}))
  window.__tourScrollSpy = onScroll
  window.addEventListener('scroll', onScroll, { passive: true })

  const tabAliases = { accommodations: 'accomodations' }
  const params = new URLSearchParams(window.location.search)
  const requested = params.get('tab') || [...params.keys()][0]
  const initialTab = tabAliases[requested] || requested

  if (initialTab && initialTab !== 'overview' && sections.some(section => section.id === initialTab)) {
    // wait a moment so images above have their size
    setTimeout(() => scrollToSection(initialTab, 'auto'), 300)
  }
}

// Popup sliders on tour pages (photo gallery, day-to-day, accommodations, incl. overview previews): clicking an item opens the slider at that item
let sliderKeyHandlers = []

const initPopupSlider = (popup, openers, formatCounter) => {
  // Popups live inside their tab, which is hidden on other tabs (e.g. overview previews), so lift them out
  const container = document.getElementById('async') || document.body
  container.appendChild(popup)

  const slides = popup.querySelectorAll('.swiper-slide')
  const counter = popup.querySelector('.js-slider-counter')
  const setCounter = index => { counter.textContent = formatCounter(index + 1, slides.length) }

  // Only load the current slide's image and its neighbours, not everything up front
  const loadAround = index => {
    [index - 1, index, index + 1].forEach(i => {
      const img = slides[i] && slides[i].querySelector('img[data-src]')
      if (img) {
        img.src = img.dataset.src
        img.removeAttribute('data-src')
      }
    })
  }

  const swiper = new Swiper(popup.querySelector('.js-slider-swiper'), {
    spaceBetween: 40,
    navigation: {
      prevEl: popup.querySelector('.js-slider-prev'),
      nextEl: popup.querySelector('.js-slider-next'),
    },
    on: {
      slideChange: s => {
        loadAround(s.activeIndex)
        setCounter(s.activeIndex)
      },
    },
  })

  const open = index => {
    popup.classList.add('is-active')
    popup.setAttribute('aria-hidden', 'false')
    document.body.classList.add('popup-slider-open')
    // The slider is built while its tab is hidden, so measure it again now it's visible
    swiper.update()
    swiper.slideTo(index, 0)
    loadAround(index)
    setCounter(index)
  }

  const close = () => {
    popup.classList.remove('is-active')
    popup.setAttribute('aria-hidden', 'true')
    document.body.classList.remove('popup-slider-open')
  }

  openers.forEach(item => {
    const index = parseInt(item.dataset.index, 10)
    item.addEventListener('click', () => open(index))
    item.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        open(index)
      }
    })
  })

  popup.querySelectorAll('.js-slider-close').forEach(el => el.addEventListener('click', close))

  const keyHandler = e => {
    if (!popup.classList.contains('is-active')) return
    if (e.key === 'Escape') close()
    if (e.key === 'ArrowLeft') swiper.slidePrev()
    if (e.key === 'ArrowRight') swiper.slideNext()
  }
  document.addEventListener('keydown', keyHandler)
  sliderKeyHandlers.push(keyHandler)
}

export const initPopupSliders = () => {
  // Drop the previous page's key handlers after an async page transition
  sliderKeyHandlers.forEach(handler => document.removeEventListener('keydown', handler))
  sliderKeyHandlers = []

  const gallery = document.querySelector('.js-gallery-popup')
  if (gallery) {
    initPopupSlider(gallery, document.querySelectorAll('.js-gallery-open'), (n, total) => `${n} / ${total}`)
  }

  const days = document.querySelector('.js-day-popup')
  if (days) {
    initPopupSlider(days, document.querySelectorAll('.js-day-open'), (n, total) => `Day ${n} of ${total}`)
  }

  // Image grid sections: each grid has its own slider with all of its photos
  document.querySelectorAll('.image_grid').forEach(section => {
    const popup = section.querySelector('.js-image-grid-popup')
    if (popup) {
      initPopupSlider(popup, section.querySelectorAll('.js-image-grid-open'), (n, total) => `${n} / ${total}`)
    }
  })

  const accommodations = document.querySelector('.js-accommodation-popup')
  if (accommodations) {
    initPopupSlider(accommodations, document.querySelectorAll('.js-accommodation-open'), (n, total) => `${n} of ${total}`)
  }
}
